import { defineMessages } from 'react-intl'

export const PROFILE_GOAL = {
  LOSE_WEIGHT: 1,
  GET_FIT: 2,
  STAY_ACTIVE: 3,
  BUILD_MUSCLE: 4,
  GET_STRONGER: 5
}

export const PROFILE_GOALS = Object.values(PROFILE_GOAL)

export const PROFILE_GOAL_EMOJI = {
  [PROFILE_GOAL.LOSE_WEIGHT]: '⚖️',
  [PROFILE_GOAL.GET_FIT]: '💪',
  [PROFILE_GOAL.STAY_ACTIVE]: '🏃',
  [PROFILE_GOAL.BUILD_MUSCLE]: '🍗',
  [PROFILE_GOAL.GET_STRONGER]: '🏋️'
}

const labels = defineMessages({
  loseWeight: {
    id: 'ProfileGoal.loseWeight',
    defaultMessage: 'Lose Weight',
    description: 'The label used for the goal of losing weight.'
  },
  getFit: {
    id: 'ProfileGoal.getFit',
    defaultMessage: 'Get Fit',
    description: 'The label used for the goal of getting fit up.'
  },
  stayActive: {
    id: 'ProfileGoal.stayActive',
    defaultMessage: 'Stay Active',
    description: 'The label used for the goal of staying active.'
  },
  buildMuscle: {
    id: 'ProfileGoal.buildMuscle',
    defaultMessage: 'Build Muscle',
    description: 'The label used for the goal of building muscle.'
  },
  getStronger: {
    id: 'ProfileGoal.getStronger',
    defaultMessage: 'Get Stronger',
    description: 'The label used for the goal of getting stronger.'
  }
})

export const PROFILE_GOAL_MESSAGE = {
  [PROFILE_GOAL.LOSE_WEIGHT]: labels.loseWeight,
  [PROFILE_GOAL.GET_FIT]: labels.getFit,
  [PROFILE_GOAL.STAY_ACTIVE]: labels.stayActive,
  [PROFILE_GOAL.BUILD_MUSCLE]: labels.buildMuscle,
  [PROFILE_GOAL.GET_STRONGER]: labels.getStronger
}

export const helpers = defineMessages({
  loseWeight: {
    id: 'ProfileGoal.loseWeightHelper',
    defaultMessage: 'Lose a large amount of body fat.',
    description: 'The second label used for the goal of losing weight.'
  },
  getFit: {
    id: 'ProfileGoal.getFitHelper',
    defaultMessage: 'Build noticeable muscle mass while decreasing your body fat.',
    description: 'The second label used for the goal of toning up.'
  },
  stayActive: {
    id: 'ProfileGoal.stayActiveHelper',
    defaultMessage: 'Maintain a healthy lifestyle by doing different type of workouts.',
    description: 'The second label used for the goal of staying active.'
  },
  buildMuscle: {
    id: 'ProfileGoal.buildMuscleHelper',
    defaultMessage: 'Get more muscle size and increase your strength.',
    description: 'The second label used for the goal of building muscle.'
  },
  getStronger: {
    id: 'ProfileGoal.getStrongerHelper',
    defaultMessage: 'Increase the amount of weight lifted without necessarily getting bigger.',
    description: 'The second label used for the goal of getting stronger.'
  }
})

export const PROFILE_GOAL_HELPER = {
  [PROFILE_GOAL.LOSE_WEIGHT]: helpers.loseWeight,
  [PROFILE_GOAL.GET_FIT]: helpers.getFit,
  [PROFILE_GOAL.STAY_ACTIVE]: helpers.stayActive,
  [PROFILE_GOAL.BUILD_MUSCLE]: helpers.buildMuscle,
  [PROFILE_GOAL.GET_STRONGER]: helpers.getStronger
}
